module.exports = __webpack_public_path__ + "static/img/system_banner_01.454e38f.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/system_banner_01.png
// module id = kgGz
// module chunks = 0